// 扫描投递
<template>
  <div class="mailScanExpressCode">
    <!-- 流程 -->
    <userSaveFlow v-if="oType === 'userSave'"></userSaveFlow>
    <userFastSaveFlow v-if="oType === 'userFastSave'"></userFastSaveFlow>
    <!-- 正文内容 -->
    <div class="wrapper clearfix">
      <div class="left">
        <p class="title">在柜子下方扫描快递单条形码</p>
        <img src="../../../../static/mailBox/images/scanExpressCode.jpg" alt="">
        <p class="text" v-if="oType == 'userSave'">请投入{{$store.state.mail_deliver.box_number}}号箱格</p>
        <p class="text" v-if="oType == 'userFastSave'">请把信件投入到一个箱格内</p>
      </div>
      <div class="right">
        <p class="title"> 
          <span class="packageText">已扫码的快递单号 （{{packageList.length}}）</span>
          <span class="manualInput" v-if="!manualChecked" @click="manualAddCode()">手动输入</span>
          <span class="manualInput" v-else @click="checkAddCode()">确定</span>
        </p>
        <el-scrollbar>
          <div 
            class="packageList"
            v-for="(item, index) in packageList"
            :key="index">
            <input
              class="number"
              type="text"
              v-model="packageList[index].number"
              :readonly="packageList[index].readonly"
              :autofocus="index==0?true:false"/>
            <img
              v-if="!packageList[index].autofocus"
              src="../../../../static/mailBox/images/icon/delete.png"
              class="delete"
              @click="deleteExpressCode(index)"/>
          </div>
        </el-scrollbar>
        <el-button class="finish"
         @click="goFinish()">结束</el-button>
      </div>
    </div>

    <!-- mqtt -->
    <mqttws ref="mqttws" @getMessage="getMessage"></mqttws>

    <!-- 底部按钮 -->
    <btnCancel></btnCancel>
  </div>
</template>

<script>
// 组件
import mqttws from '../../../assets/mqttws2'
import btnCancel from '../common/btnCancel'
import userSaveFlow from '../userSave/userSaveFlow'
import userFastSaveFlow from '../userFastSave/userFastSaveFlow'

// js
import {
  showToast,
  showLoading,
  hideLoading,
  sendPackageNo
} from '../../../../static/mailBox/js/request.js'
import { storage } from '../../../../static/js/utils/utility'

export default {
  name: 'mailBoxScanExpressCode',

  components: {
    mqttws,
    btnCancel,
    userSaveFlow,
    userFastSaveFlow
  },

  data () {
    return {
      oType: '',
      packageList: [],
      manualChecked: false,
    }
  },

  created () {
    this.oType = this.$store.state.mail_oType
    this.$store.state.mail_deliver.t_package_no = []
    if (this.oType === 'userSave') { // 普通存件
      // this.$store.state.mail_index = 3
      this.$store.commit('mail_index', 3)
    } else if (this.oType === 'userFastSave') { // 快速存件
      // this.$store.state.mail_index = 2
      this.$store.commit('mail_index', 2)
    }
    console.log('用户选择的业务类型：', this.$store.state.mail_oType)
    console.log('用户的身份：', this.$store.state.mail_type)
    console.warn('到扫描快递单页面时候的订单数据：', this.$store.state.mail_deliver)
  },

  mounted () {
    
  },
  watch: {

  },
  methods: {
    // 获取mqtt信息
    getMessage(res){
      console.log('mqtt返回信息',res)
      let vm = this
      // type信息类型：identityCheck为身份认证， Exp为扫描快递单号
      if (res.type === 'Exp') {
        if (res.meta.code === 200) {
          console.log('扫描的单号', res.data.t_package_no)
          if (vm.packageList.length !== 0) {
            for (let i in vm.packageList) { // 遍历单号数组，是否有重复单号
              if (res.data.t_package_no === vm.packageList[i].number) {
                showToast('请扫描新的快递条码')
                return
              }
            }
          }
          vm.packageList.unshift({number: res.data.t_package_no, readonly: true, autofocus: false})
        } else {
          showToast(res.meta.message)
        }
      }
    },

    // 手动添加快递单号，出现输入框，自动获取焦点
    manualAddCode: function () {
      let vm = this
      vm.manualChecked = true
      vm.packageList.unshift({number: null, readonly: false, autofocus: true})
    },

    // 确定完成输入单号，失去焦点，显示删除图标
    checkAddCode: function () {
      let vm = this
      vm.manualChecked = false
      for (let i = 0; i < vm.packageList.length; i++) {
        vm.packageList[i].autofocus = false
      }
    },

    // 删除快递单号/输入内容
    deleteExpressCode: function (index) {
      this.packageList.splice(index, 1)
      // console.log('this.packageList', this.packageList)
    },

    // packageList只提取单号作为数组元素
    packageProcessor: function (list) {
      let packageList = []
      for (let i = 0; i< list.length; i++) {
        packageList.push(list[i].number)
      }
      return packageList
    },

    // 去完成存件
    goFinish: function () {
      let vm = this
      console.log('点击完成时候，vm.packageList：', vm.packageList)
      if (vm.packageList.length === 0) {
        showToast('请扫描快递条码')
        return
      } else {
        for (let i in vm.packageList) {
          if (vm.packageList[i].number === null) {
            showToast('请检查快递单号是否输入')
            return
          }
        }
      }
      vm.$store.state.mail_deliver.t_package_no = vm.packageProcessor(vm.packageList)
      vm.deliver()
    },
    
    // 提交订单数据，返回取件人箱格号，提示存件人把快递存入对应箱格
    deliver: async function () {
      let vm = this
      vm.isLoading = true
      let device_no_id = storage.localGetItem('device_no_id')
      let data = {...vm.$store.state.mail_deliver, device_no_id}
      console.log('data', data)
      let box = {
        number: '',
        error: false,
        status: false,
      }
      let res = await sendPackageNo(data)
      vm.isLoading = false
      // 红外检测到您没有投递信件
      if (res.meta.code == 403) {
        this.$alert('<p style="line-height:35px">'+res.meta.message+'</p>', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          center: true,
          dangerouslyUseHTMLString: true
        }).then(() => {
          console.log('yes', '')
        }).catch(() => {
        })
      } else {
        let code = res.meta.code
        box.status = true
        box.error = code == 200 ? true : false
        if (res.data.box_number) {
          box.number = res.data.box_number
        } else {
          box.number = ''
        }
        if (code != 200) {
          box.message = res.meta.message
        }
        vm.$store.state.mail_box = box
        vm.$router.push({
          // 你要跳转的地址
          path: '/mailBox/common/saveFinish'
        })
      }
    },
  }
}
</script>

<style lang="less" scoped>
.alertText {
  line-height: 30px;
}
.mailScanExpressCode {
  .wrapper {
    width: 13.75rem;
    margin: 0.6rem auto 0;
    .left {
      width: 6rem;
      float: left;
      margin-right: 1rem;
    }
    .left img {
      width: 100%;
    }

    .left .text {
      font-size: 0.5rem;
      text-align: center;
      margin-top: 0.3rem;
    }

    .right {
      width: 5.8rem;
      float: left;
    }

    .right .el-scrollbar {
      height: 3.25rem;
      padding-right: 0.2rem; 
    }

    .right .packageList {
      display: block;
      width: 100%;
      position:relative;
    }

    .right .packageList .number {
        display: block;
        width: 100%;
        height:0.7rem;
        line-height:0.7rem;
        color: #606266;
        font-size: 0.3rem;
        padding: 0 0.2rem;
        margin-bottom: 0.2rem;
        background-color: #ffffff;
        border-radius: 4px;
        border: 1px solid#dcdfe6;
    }

    .right .packageList .delete {
      display: block;
      width: 0.35rem;
      height: 0.35rem;
      position: absolute;
      right: 0.2rem;
      top: 0;
      bottom: 0;
      margin: auto 0;
    }

    .right .el-button {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      color: #ffffff;
      background: linear-gradient(0deg,#0669be,#4babfe);
      border: none;
      padding: 0;
      margin-top: 0.2rem;
    }

    .title {
      font-size: 0.3rem;
      line-height: 0.9rem;
      position: relative; 
      height: 0.9rem;
    }

    .title .packageText {
      position: absolute; 
      left: 0;
    }

    .title .manualInput {
      color: #333;
      padding: 0 0.1rem;
      width: 1.2rem;
      height: 0.6rem;
      font-size: 0.2rem;
      line-height: 0.6rem;
      border-radius: 0.05rem;
      background-color: #ffffff;
      position: absolute;
      right: 0.2rem;
      top: 0.15rem;
    }
    
    .finish {
      font-size: 0.3rem;
    }
  }
  .backBtn {
    display: block;
    width: 2.04rem;
    height: 0.88rem;
    line-height: 0.88rem;
    font-size: 0.34rem;
    border-radius: 0.1rem;
    text-align: center;
    color: #ffffff;
    background: linear-gradient(to top, #0669be, #4babfe);
    position: absolute;
    right: 3rem;
    bottom: 1rem;
    z-index: 2;
  }
  input, textarea {
    -webkit-user-select: auto!important;
    -khtml-user-select: auto!important;
    -moz-user-select: auto!important;
    -ms-user-select: auto!important;
    -o-user-select: auto!important;
    user-select: auto!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mailBox/userSave/scanExpressCode.vue